/**
 * Built-in profile / registration interests (selectable catalog — not auto-assigned on signup).
 * Admin-managed list is stored in Firestore (`system/interests`) and overrides these at runtime.
 */
export const DEFAULT_INTERESTS = [
  { id: 'gym', label: 'Gym', emoji: '🏋️' },
  { id: 'cards', label: 'Cards', emoji: '🃏' },
  { id: 'tabletop', label: 'Tabletop', emoji: '🎲' },
  { id: 'therapy', label: 'Therapy', emoji: '🧠' },
  { id: 'camping', label: 'Camping', emoji: '⛺' },
  { id: 'vegan', label: 'Vegan', emoji: '🌱' },
  { id: 'wfh', label: 'WFH', emoji: '💻' },
  { id: 'golf', label: 'Golf', emoji: '⛳' },
  { id: 'fine_dining', label: 'Fine Dining', emoji: '🍽️' },
  { id: 'yoga', label: 'Yoga', emoji: '🧘' },
  { id: 'meditation', label: 'Meditation', emoji: '🕯️' },
  { id: 'sober', label: 'Sober', emoji: '🧃' },
  { id: 'fishing', label: 'Fishing', emoji: '🎣' },
  { id: 'sports', label: 'Sports', emoji: '🏅' },
  { id: 'video_games', label: 'Video Games', emoji: '🎮' },
  { id: 'cannabis', label: '🌿 🍄', emoji: '' },
  { id: 'plants_nature', label: 'Plants & Nature', emoji: '🍃🍄' },
  { id: 'coffee', label: 'Coffee', emoji: '☕' },
];
